import { elementExistFunction } from '@/utils/lazy-init';

export default function () {
    elementExistFunction('[app="feaas"]', (elements) => import('./feaaswrapper').then(x => x.init(elements)));
}
